import { trackSchemaEvent, trackSimpleEvent } from "metabase/analytics";
import type Question from "metabase-lib/v1/Question";
import type { Card, VisualizationDisplay } from "metabase-types/api";

export const trackNewQuestionSaved = (
  draftQuestion: Question,
  createdQuestion: Question,
  isBasedOnExistingQuestion: boolean,
) => {
  trackSchemaEvent("question", {
    event: "new_question_saved",
    question_id: createdQuestion.id(),
    database_id: createdQuestion.databaseId(),
    visualization_type: createdQuestion.display(),
    type: draftQuestion.creationType(),
    method: isBasedOnExistingQuestion ? "existing_question" : "from_scratch",
  });
};

export const trackTurnIntoModelClicked = (question: Question) => {
  trackSchemaEvent("question", {
    event: "turn_into_model_clicked",
    question_id: question.id(),
  });
};

export const trackNotebookNativePreviewShown = (
  question: Question,
  isShown: boolean,
) => {
  trackSchemaEvent("question", {
    event: isShown
      ? "notebook_native_preview_shown"
      : "notebook_native_preview_hidden",
    // question_id is not nullable in the schema, and we cannot change it
    question_id: question.id() ?? 0,
  });
};

export const trackFirstNonTableChartGenerated = (
  display: VisualizationDisplay,
) => {
  trackSimpleEvent({
    event: "chart_generated",
    event_detail: display,
  });
};

export const trackCardBookmarkAdded = (card: Card) => {
  trackSimpleEvent({
    event: "bookmark_added",
    event_detail: card.type,
    triggered_from: "qb_action_panel",
  });
};
